var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ut-nav',{attrs:{"theme":_vm.theme,"unique-opened":"","mode":_vm.mode,"router":_vm.router,"collapse":_vm.navCollapse}},_vm._l((_vm.data),function(item){return _c('navPane',{key:item.id,attrs:{"data":item}})}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }